import { Box, Link, Typography } from "@mui/material";
import type { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FONT_SIZE, INK } from "../../theme/tokens";
import { SUPPORT_EMAIL } from "../../utils/models";

// `pretty` keeps a centred footnote from ending on a single orphaned word on a phone.
const FOOTNOTE_SX = { fontSize: FONT_SIZE.SECONDARY, lineHeight: 1.5, color: INK.MUTED, textWrap: "pretty" } as const;

/** The advice under the card's divider: check unsaved work, and who to contact meanwhile. */
export const MaintenanceFootnotes: FC = () => {
	const { t } = useTranslation();
	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1, px: { xs: 3, sm: 5 }, py: 2.5, textAlign: "center" }}>
			<Typography component="p" sx={FOOTNOTE_SX}>
				{t("maintenance.unsaved.changes")}
			</Typography>
			<Typography component="p" sx={FOOTNOTE_SX}>
				<Trans
					// Passing `t` makes the element depend on the language; without it the React Compiler memoises it in the first one.
					t={t}
					i18nKey="maintenance.help"
					values={{ email: SUPPORT_EMAIL }}
					components={{
						// Not `link`: that is a void HTML tag to the Trans parser, which would drop the address out of the anchor.
						mail: (
							// An LTR address inside Hebrew text: isolated, so the full stop after it stays at the sentence's end.
							<Link
								href={`mailto:${SUPPORT_EMAIL}`}
								dir="ltr"
								data-testid="maintenance-screen-support-email"
								sx={{ fontWeight: 600, unicodeBidi: "isolate", whiteSpace: "nowrap" }}
							/>
						),
					}}
				/>
			</Typography>
		</Box>
	);
};
